<script setup lang="ts">
import { isValidDomain, sanitizeDomain } from '../utils/domain'

const props = defineProps<{
  isOpen: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'apply', domain: string): void
}>()

const { t } = useI18n()

const url = ref('')
const error = ref('')

watch(
  () => props.isOpen,
  (isOpen) => {
    if (isOpen) {
      url.value = ''
      error.value = ''
    }
  }
)

const onUrlInput = (value: string | number) => {
  url.value = String(value)
  error.value = ''
}

const handleApply = () => {
  const domain = sanitizeDomain(url.value)

  if (!isValidDomain(domain)) {
    error.value = t('pages.domain.config.steps.domain.pasteModal.error')
    return
  }

  emit('apply', domain)
  emit('close')
}
</script>

<template>
  <BaseModal
    :is-open="isOpen"
    size="lg"
    :heading-title="t('pages.domain.config.steps.domain.pasteModal.title')"
    :cancel="t('pages.domain.config.buttons.cancel')"
    :link-text="t('pages.domain.config.steps.domain.pasteModal.confirm')"
    :is-disabled="!url"
    @close="$emit('close')"
    @click="handleApply"
  >
    <div class="flex flex-col gap-4">
      <p class="text-sm text-muted-foreground">
        {{ t('pages.domain.config.steps.domain.pasteModal.description') }}
      </p>
      <AppFormInput
        id="pasteUrl"
        :model-value="url"
        :label="t('pages.domain.config.steps.domain.pasteModal.inputLabel')"
        type="text"
        :placeholder="t('pages.domain.config.steps.domain.pasteModal.inputPlaceholder')"
        name="pasteUrl"
        :errors="error ? [error] : []"
        @update:model-value="onUrlInput"
        @keyup.enter="handleApply"
      />
    </div>
  </BaseModal>
</template>
